import { useEffect, useState } from 'react'
import { Wrapper, Header, ModalContent, ModalFooter } from './styles'
import CloseButton from 'src/global/CloseButton'
import { useDispatch, useSelector } from 'react-redux'
import { State } from 'src/state'
import { Backdrop } from 'src/global'
import Button from 'src/global/Button'
import { getCurrentUser } from 'src/state/users'
import { userEndpoints } from 'src/api'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowDown, faCheck, faChevronDown, faKey } from '@fortawesome/free-solid-svg-icons'
import { IS_DESKTOP_OR_TABLET } from 'src/screens/HomeScreen'

export default function WaiterLoginModal() {
  const { user } = useSelector((state: State) => state.users)
  const qrCodeUrl = `${process.env.REACT_APP_MENU_BASE_URL}/${user?.username || ''}/my-login-qr-code.svg`
  const dispatch = useDispatch()

  const [isOpen, setIsOpen] = useState(false)
  const [imageSrc, setImageSrc] = useState('')
  const [activeStep, setActiveStep] = useState<1 | 2>(1)

  useEffect(() => {
    window['openWaiterLoginModal'] = open
    setTimeout(() => {
      getQrCodeImage()
    }, 1000)
  }, [])

  const open = () => {
    userEndpoints.registerUserAction({ actionType: 'OpenWaiterLoginModal', data: {} })
    setIsOpen(true)
    setActiveStep(1)
  }

  const close = () => {
    setIsOpen(false)
    setTimeout(() => {
      dispatch(getCurrentUser())
    }, 0)
  }

  const getQrCodeImage = async () => {
    const blob = await fetch(qrCodeUrl, { headers: { Authorization: `Bearer ${localStorage.token}` } }).then(r => r.blob())
    const objectUrl = window.URL.createObjectURL(blob)
    setImageSrc(objectUrl)
  }

  return (
    <>
      <Backdrop onClick={close} className={isOpen ? 'open' : 'closed'} />
      <Wrapper className={isOpen ? 'open' : 'closed'}>
        <Header>
          Adaugă Dispozitiv de Ospătar
          <CloseButton onClick={close} title="Închide" style={{ marginTop: '-18px' }} />
        </Header>

        <ModalContent>
          <div className={`step ${activeStep === 1 ? 'active' : ''}`}>
            <div className="step-header" onClick={() => setActiveStep(activeStep === 1 ? 2 : 1)}>
              <span className="step-number">Pasul 1</span>
              <h3>
                Instalează aplicația{' '}
                {IS_DESKTOP_OR_TABLET && (
                  <span className="app-badge">
                    <img src="/logo.svg" alt="MeniuDigital" />
                    MeniuDigital
                  </span>
                )}
              </h3>
              <FontAwesomeIcon icon={faChevronDown} className="chevron" />
            </div>
            <div className="step-body">
              {IS_DESKTOP_OR_TABLET && (
                <>
                  <p className="step-description">Scanează acest cod QR pentru a instala aplicația:</p>
                  <div className="qr-code-wrapper">
                    <img
                      className="qr-code"
                      src={`${process.env.REACT_APP_MENU_BASE_URL}/get-app-qr-code.svg`}
                      alt="Download App QR"
                    />
                    <img src="/logo.svg" alt="MeniuDigital" className="center-icon" />
                  </div>
                  <p className="step-description">sau descarcă direct din:</p>
                </>
              )}
              <div className="store-badges">
                <a
                  href="https://itunes.apple.com/ro/app/meniudigital/id6443401368?mt=8"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src="/icons/app-store-badge.svg" alt="Download on App Store" />
                </a>
                <a
                  href="https://play.google.com/store/apps/details?id=ro.meniudigital.meniudigital"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src="/icons/google-play-badge.png" alt="Get it on Google Play" />
                </a>
              </div>
              <Button
                className="next-step-button"
                onClick={() => setActiveStep(2)}
                text="Am instalat aplicația"
                icon={faArrowDown}
              />
            </div>
          </div>

          <div className={`step ${activeStep === 2 ? 'active' : ''}`}>
            <div className="step-header" onClick={() => setActiveStep(activeStep === 2 ? 1 : 2)}>
              <span className="step-number">Pasul 2</span>
              <h3>Autentifică-te{IS_DESKTOP_OR_TABLET && ' ca ospătar'}</h3>
              <FontAwesomeIcon icon={faChevronDown} className="chevron" />
            </div>
            <div className="step-body">
              <p className="step-description">
                {IS_DESKTOP_OR_TABLET
                  ? 'Ai deja aplicația? Scanează codul QR de mai jos cu aplicația '
                  : 'Scanează cu aplicația '}
                <span className="app-badge">
                  <img src="/logo.svg" alt="MeniuDigital" />
                  MeniuDigital
                </span>{' '}
                pentru a te autentifica.
              </p>
              <div className="qr-code-wrapper login-qr">
                <img className="qr-code" src={imageSrc} alt="Login QR" />
                <FontAwesomeIcon icon={faKey} className="center-icon" />
              </div>
            </div>
          </div>
        </ModalContent>

        <ModalFooter>
          <Button onClick={close} text="Gata" icon={faCheck} />
        </ModalFooter>
      </Wrapper>
    </>
  )
}
